import ExtendedPath from "csi/core/ExtendedPath";
import Key from "csi/core/Key";
import locale from "csi/locale";
import { PreferenceView } from "csi/prefs/PreferenceView";
import PropertyWidget from "csi/property/Widget";
import { VALUE_TYPE } from "csi/typings";
import declare from "dojo/_base/declare";
import _ from "lodash";

const UserDefaultsController = declare(PropertyWidget, {
	/**
	 * @override
	 * Initialize attributeKeys based on attributes on root class
	 */
	getDefaultCustomView(): PreferenceView {
		const rc = this.defView.getRootClass();
		const extendedPath = ExtendedPath.create(rc);
		const attributes = rc.getAttributes().filter(({ valueType }) => (valueType == VALUE_TYPE.BOOLEAN) || (valueType == VALUE_TYPE.ENUM) || (valueType == VALUE_TYPE.ENUM_LIST));
		const sortedAttributes = _.sortBy(attributes, (rca) => locale.typeId(rc.type, rca.attributeId));
		const sortedKeys = sortedAttributes.map(({ attributeId }) => new Key({ extendedPath, id: attributeId }).typedString);

		this.set("attributeKeys", sortedKeys);

		return this.inherited<PreferenceView>(arguments);
	},
});

export = UserDefaultsController;